export default __webpack_public_path__ + "static/media/5_pelvic_flows_motivation.e0adc0a4.png";